import { Box, Card, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { ChangeEvent, FC } from "react";
import { DeploymentResponseDto } from "~/gen/api/deploy";
import { useDeploymentDetailContext } from "~/pages/deployment/useDeploymentDetailContext";
import { BasicInfoPiece, BasicInfoRow } from "../backups/BackupBasicInfoCard";

const DeploymentSelectionCard: FC = () => {
  const {
    databases,
    currDatabase,
    setCurrDatabase,
  } = useDeploymentDetailContext()

  const handleDbSelect = (e: SelectChangeEvent<DeploymentResponseDto | ''>) => {
    if (e.target.value === '') return

    const db = e.target.value as DeploymentResponseDto
    setCurrDatabase(db)
  }

  return (
    <Card>
      <BasicInfoRow>
        <BasicInfoPiece>
          <Typography
            color="textPrimary"
            variant="h6"
          >
            Database
          </Typography>
          <Box>
            <Select
              fullWidth
              size="small"
              variant="outlined"
              onChange={handleDbSelect}
              value={currDatabase || ''}
            >
              {databases.map(d => (
                <MenuItem key={d.deploymentId} value={d as any} >{d.name}</MenuItem>))
              }
            </Select>
          </Box>
        </BasicInfoPiece>
      </BasicInfoRow>
    </Card>
  )
}

export default DeploymentSelectionCard;
